export default "__VITE_ASSET__D_739D6D__"